import SectionHeading from '@/components/base/SectionHeading';
import { introPoints } from '@/mocks/home';

export default function IntroSection() {
  return (
    <section id="intro" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="吃瓜入门"
          title="开始之前，先把「吃瓜」这件事弄明白"
          desc="很多新手一上来就刷信息流，结果瓜吃了一半就断了线。先花两分钟搞清楚概念和入口，后面的每一步都会轻松很多。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 lg:grid-cols-3">
          {introPoints.map((point) => (
            <article
              key={point.title}
              className="group rounded-lg border border-background-200/80 bg-background-100/60 p-6 transition-colors hover:border-primary-300/70 hover:bg-background-100"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${point.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{point.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-5 rounded-lg border border-secondary-200/70 bg-secondary-50 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
              <i className="ri-alert-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">围观有边界，理性是最好的姿势</h3>
              <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">
                吃瓜是休闲，不是战场。不传播未经证实的消息、不参与攻击性讨论、尊重当事人隐私，才是一个成熟围观者的基本素养。
              </p>
            </div>
          </div>
          <a
            href="#faq"
            className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-3 font-label text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-100"
          >
            <i className="ri-question-line text-base" aria-hidden="true"></i>
            看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}